import { render } from "./DropDownListPcoProjeto.vue?vue&type=template&id=868e8e90&ts=true"
import script from "./DropDownListPcoProjeto.vue?vue&type=script&lang=ts"
export * from "./DropDownListPcoProjeto.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__